import React, { FC, useState, MouseEvent } from 'react'
import { Link } from 'gatsby'
import bp from '../../../styles/constants.module.scss'
import { cls } from '../../../utils/utils'
import { ROUTE_PATH } from '../../../utils/constants'
import { headerMenuItems } from './HeaderMenu.constants'
import styles from './HeaderMenu.module.scss'

const subsectionStyle = (isOpened: boolean): string => {
  return isOpened ? `${styles.subsection} ${styles.visible}` : styles.subsection
}

const hoverNotUsed = (): boolean => {
  return !window.matchMedia('(hover: hover)').matches || window.matchMedia(`(max-width: ${bp.bpLarge})`).matches
}

export const HeaderMenu: FC<Record<string, never>> = () => {
  const [openedSubsection, setOpenedSubsection] = useState<number>(-1)

  const handleSubsectionClick = (newSubsection: number, itemName: string, event: MouseEvent<HTMLAnchorElement>): void => {
    if (itemName === ROUTE_PATH.news.name) {
      localStorage.removeItem('pageState')
      localStorage.removeItem('scrollState')
      localStorage.setItem('currentPage', JSON.stringify({ isTagPage: false }))
    }

    if (newSubsection !== -1 && (hoverNotUsed() || openedSubsection !== -1)) {
      setOpenedSubsection(openedSubsection === newSubsection ? -1 : newSubsection)
      event.preventDefault()
    }
  }

  return (
    <ul className={styles.pageLinks}>
      {headerMenuItems.map((item, itemId) => (
        <li className={cls(item.highlighted && styles.highlighted)} key={item.link.path + item.link.name}>
          <Link
            to={item.link.path}
            key={item.link.path + item.link.name}
            className={cls(styles.mainLink, item.subitems && styles.linkGap)}
            activeClassName={styles.current}
            partiallyActive
            onClick={handleSubsectionClick.bind(null, item.subitems ? itemId : -1, item.link.name)}
          >
            {item.link.name}
            {item.subitems ? <span className={styles.subsectionMarker}></span> : null}
          </Link>
          {item.subitems && (
            <div className={subsectionStyle(openedSubsection === itemId)}>
              <ul>
                {item.subitems.map((subitem) => (
                  <li key={subitem.path + subitem.name}>
                    <Link
                      to={subitem.path}
                      activeClassName={styles.current}
                      key={subitem.path + subitem.name}
                      onClick={() => {
                        if (item.link.name === ROUTE_PATH.news.name) {
                          localStorage.removeItem('pageState')
                          localStorage.removeItem('scrollState')
                          localStorage.setItem('currentPage', JSON.stringify({ isTagPage: false }))
                        }
                      }}
                    >
                      {subitem.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </li>
      ))}
    </ul>
  )
}

export default HeaderMenu
